export default {
  kvText: 'Ưu Đãi Tháng 11\nĐại Tiệc HOT Deal Ngập Tràn!',
  countdown: {
    start: 'Sự kiện bắt đầu: {time}',
    end: 'Sự kiện kết thúc: {time}',
  },
  verify: {
    title: 'Xác thực Tài khoản',
    placeholder: 'Nhập ID Tài khoản',
    accountId: 'ID Tài khoản',
    accountName: 'Tên Tài khoản',
    login: 'Đăng nhập',
    confirm: 'Xác nhận thông tin Tài khoản',
    switchAccount: 'Nhập lại',
  },
  plaza: 'Trung Tâm Mua Sắm',
  desc: 'Truy cập trang Nạp chính thức [{clickHere}]. Nạp 100 KCSM sẽ nhận 1 Phiếu Mua. Sử dụng Phiếu Mua để đổi thưởng hấp dẫn tại Trung Tâm Mua Sắm!',
  clickHere: 'Nhấn vào đây',
  eventTime: 'Thời gian sự kiện: 00:00 ngày 06/11/2026 – 23:59 ngày 15/11/2026 (GMT+7)\nThời hạn nhận thưởng kết thúc lúc 23:59 ngày 22/11/2026 (GMT+7).',
  remaining: 'Phiếu Mua còn lại: {n}',
  remainingLabel: 'Phiếu Mua còn lại:',
  goods: {
    hotDeals: 'Ưu đãi HOT',
    dailyDeals: 'Deal Mỗi Ngày',
    viewDaily: 'Danh sách Deal Mỗi Ngày',
    price: '{n} Phiếu Mua',
    purchase: 'Mua',
    remainTimes: 'Số lượt Mua còn lại: {n}',
    notEnoughVoucher: 'Không đủ Phiếu Mua',
    soldOut: 'Hết Hàng',
    max: 'MAX',
    confirm: 'Chắc chắn dùng {n} Phiếu Mua để mua {name} không?',
    success: 'Mua thành công. Đăng nhập vào game và kiểm tra [Thư] ngay.',
    history: 'Lịch sử Mua',
    spent: 'Phiếu Mua đã sử dụng',
    details: 'Chi tiết Mua',
    time: 'Thời gian Mua',
    expired: 'Vật phẩm này đã hết hạn. Làm mới trang và chọn lại.',
    notEnoughDesc: 'Không đủ Phiếu Mua. Hãy nạp KCSM để nhận thêm Phiếu Mua.',
  },
  milestone: {
    allAchieved: 'Bạn có thể nhận tất cả phần thưởng',
    subtitle: 'Tiêu đủ Phiếu Mua để nhận Rương Cao Cấp!',
    topUp: 'Nạp ngay',
    history: 'Lịch sử nhận Thưởng',
    claimAll: 'Nhận Tất Cả',
    nextTip: 'Dùng thêm {n} Phiếu Mua để nhận phần thưởng tiếp theo',
    obtained: 'Đã nhận',
    claimable: 'Có thể nhận',
    notAchieved: 'Chưa đạt',
    spend: 'Dùng {n} Phiếu Mua',
    header: 'Mốc',
    rewardDetails: 'Chi tiết Thưởng',
    claimTime: 'Thời gian Nhận',
    claimSuccess: 'Nhận Thưởng thành công!',
    claimAllSuccessDesc: 'Đã nhận tất cả phần thưởng có thể nhận!\nXem chi tiết tại {history}.',
    claimSuccessDesc: 'Nhận thành công! Đăng nhập vào game và nhận thưởng qua [Thư] ngay!',
  },
  common: {
    empty: 'Chưa có bản ghi',
    confirm: 'Xác nhận',
    cancel: 'Hủy',
  },
  rule: {
    title: 'Hướng dẫn SK',
    content: [
      '1. Trong thời gian diễn ra sự kiện, nạp KCSM qua Trang Nạp Chính Thức để nhận Phiếu Mua. Cứ mỗi 100 KCSM được nạp, bạn sẽ nhận 1 Phiếu Mua.',
      '2. Sử dụng Phiếu Mua tại Trung Tâm Mua Sắm để đổi nhiều vật phẩm hấp dẫn, bao gồm Khung độc quyền - [Chuyên gia]\nBạn có thể mua 1 món đồ giá trị với [Deal Mỗi Ngày] -  với chỉ 1 Phiếu Mua. Lưu ý: vật phẩm thuộc [Deal Mỗi Ngày] sẽ được làm mới vào 00:00(GMT+7) hàng ngày.',
      '3. Mỗi lần sử dụng Phiếu Mua sẽ được tích lũy vào tiến độ mua sắm. Khi đạt các mốc tiến độ quy định, bạn sẽ nhận được Rương Mốc tương ứng.',
      '4. Phiếu Mua chưa sử dụng sẽ hết hạn khi sự kiện kết thúc, vui lòng sử dụng trước thời hạn. Phần thưởng mốc chưa nhận sẽ được tự động gửi qua thư trong game.',
      '5. Vui lòng tham gia sự kiện qua kênh thanh toán bên thứ ba chính thức được chỉ định. Các trường hợp hoàn tiền, đơn hàng bất thường hoặc vi phạm quy định sẽ được xử lý quyền tham gia và phần thưởng theo thể lệ sự kiện.',
      '6. Mọi thắc mắc vui lòng liên hệ qua nút Chăm sóc Khách hàng trên trang này hoặc kênh Chăm sóc Khách hàng trong game.',
    ].join('\n\n'),
  },
  status: {
    notStart: 'Sự kiện chưa bắt đầu',
    ended: 'Sự kiện đã kết thúc',
  },
}
